import { render, staticRenderFns } from "./SignFormEditorCanvas.vue?vue&type=template&id=caa0f140&scoped=true&"
import script from "./SignFormEditorCanvas.vue?vue&type=script&lang=ts&"
export * from "./SignFormEditorCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa0f140",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
